<mat-card class="settingsBody" *ngIf="dataReady">
    <span class="settings-heading" *ngIf="dataReady">Account Details</span>
    <tab [tabs]="tabs" (tabChange)="tabChangeHandler($event)"></tab>
    <div
        [ngClass]="{
            'disable-for-quickview': isEditMenuOpen,
            'padding-24': !isEditMenuOpen
        }"
    >
        <ng-container *ngIf="tabActiveIndex === 0">
            <span class="settings-sub-heading">Company Information</span>
            <button mat-button primary (click)="edit()" style="float: right">Edit Record</button
            ><br />
            <br />

            <div class="accountDetails" *ngIf="companyFullModel">
                <div class="infoCard">
                    <div class="infoCardTitle">Company Name---</div>
                    <div class="infoCardDetails">
                        {{ companyFullModel.clientDetails.fullName }}
                    </div>
                </div>
                <div class="infoCard" *ngIf="isLBA">
                    <div class="infoCardTitle">Company Short Name</div>
                    <div class="infoCardDetails">
                        {{ companyFullModel.clientDetails.shortName }}
                    </div>
                </div>
                <div class="infoCard">
                    <div class="infoCardTitle">Company URL</div>
                    <div class="infoCardDetails">
                        <ng-container *ngIf="companyFullModel.clientDetails.companyURL">
                            <a href="companyFullModel.clientDetails.companyURL" target="_blank">{{
                                companyFullModel.clientDetails.companyURL
                            }}</a>
                        </ng-container>
                    </div>
                </div>
                <div class="infoCard">
                    <div class="infoCardTitle">CompenSafe URL</div>
                    <div class="infoCardDetails">
                        <ng-container *ngIf="companyFullModel.clientDetails.compenSafeUrl">
                            <a
                                href="companyFullModel.clientDetails.compenSafeUrl"
                                target="_blank"
                                >{{ companyFullModel.clientDetails.compenSafeUrl }}</a
                            >
                        </ng-container>
                    </div>
                </div>
                <div class="infoCard">
                    <div class="infoCardTitle">HubSpot URL</div>
                    <div class="infoCardDetails">
                        <ng-container *ngIf="companyFullModel.clientDetails.hubSpotUrl">
                            <a href="companyFullModel.clientDetails.hubSpotUrl" target="_blank">{{
                                companyFullModel.clientDetails.hubSpotUrl
                            }}</a>
                        </ng-container>
                    </div>
                </div>
                <div class="infoCard">
                    <div class="infoCardTitle">Subscription</div>
                    <div class="infoCardDetails">
                        {{ companyFullModel.clientDetails.subscriptionType }}
                    </div>
                </div>
                <div class="infoCard">
                    <div class="infoCardTitle">Account Status</div>
                    <div class="infoCardDetails">
                        {{ companyFullModel.clientDetails.clientAccountStatus }}
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="tabActiveIndex === 2">
            <span class="settings-sub-heading">Company Identities</span>
            <mat-card style="padding: 10px">
                <div class="accountDetails" *ngIf="companyFullModel">
                    <div style="display: flex; flex-direction: column">
                        <div class="infoCard" style="float: left">
                            <div class="infoCardTitle">HMDA Lender ID</div>
                            <div class="infoCardDetails">
                                <ng-container *ngIf="clientHmdaIdentities">
                                    <div style="display: flex; justify-content: flex-end">
                                        <ng-container *ngIf="hmdaIsEditing">
                                            <button
                                                type="button"
                                                mat-raised-button
                                                (click)="addBlankIdentity('HMDA')"
                                                style="height: 22px; width: 90px"
                                            >
                                                Add
                                            </button>
                                            <button
                                                type="button"
                                                mat-raised-button
                                                (click)="submitIdentityForm('HMDA')"
                                                style="
                                                    height: 22px;
                                                    width: 90px;
                                                    padding-left: 15px;
                                                "
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                mat-raised-button
                                                (click)="cancelEditedIdentities('HMDA')"
                                                style="
                                                    height: 22px;
                                                    width: 90px;
                                                    padding-left: 15px;
                                                "
                                            >
                                                Cancel
                                            </button>
                                        </ng-container>
                                        <ng-container *ngIf="!hmdaIsEditing">
                                            <button
                                                type="button"
                                                mat-raised-button
                                                (click)="addBlankIdentity('HMDA')"
                                                style="height: 22px; width: 90px"
                                            >
                                                Add
                                            </button>
                                            <ng-container
                                                *ngIf="hmdaIdentityControlsArray.length !== 0"
                                            >
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    (click)="editIdentities('HMDA')"
                                                    style="
                                                        height: 22px;
                                                        width: 90px;
                                                        padding-left: 15px;
                                                    "
                                                >
                                                    Edit
                                                </button>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                    <ng-container
                                        *ngIf="
                                            (hmdaIdentityControlsArray.length === 0 &&
                                                hmdaIsEditing) ||
                                            hmdaIdentityControlsArray.length !== 0
                                        "
                                    >
                                        <form
                                            [formGroup]="hmdaIdentityForm"
                                            (ngSubmit)="submitIdentityForm('hmda')"
                                        >
                                            <table class="identityTable">
                                                <thead>
                                                    <tr>
                                                        <td>Identifier</td>
                                                        <td>Active Date</td>
                                                        <td>Inactive Date</td>
                                                        <td></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container
                                                        formArrayName="hmdaIdentityControlsArray"
                                                        *ngFor="
                                                            let hmdaId of hmdaIdentityControlsArray;
                                                            let i = index
                                                        "
                                                    >
                                                        <tr [formGroupName]="i">
                                                            <td>
                                                                <ng-container *ngIf="hmdaIsEditing">
                                                                    <mat-form-field
                                                                        class="form-field"
                                                                    >
                                                                        <input
                                                                            formControlName="identifier"
                                                                            class="text-field"
                                                                            type="text"
                                                                            maxlength="20"
                                                                            outlined
                                                                            matInput
                                                                        />
                                                                    </mat-form-field>
                                                                </ng-container>
                                                                <ng-container
                                                                    *ngIf="!hmdaIsEditing"
                                                                >
                                                                    <mat-form-field
                                                                        class="form-field"
                                                                    >
                                                                        <input
                                                                            formControlName="identifier"
                                                                            class="text-field"
                                                                            type="text"
                                                                            maxlength="20"
                                                                            outlined
                                                                            matInput
                                                                        />
                                                                    </mat-form-field>
                                                                </ng-container>
                                                            </td>

                                                            <td>
                                                                <ng-container *ngIf="hmdaIsEditing">
                                                                    <mat-form-field
                                                                        class="light-border text-field"
                                                                        outlined
                                                                        style="
                                                                            display: block;
                                                                            height: 56px;
                                                                        "
                                                                    >
                                                                        <kendo-datepicker
                                                                            style="
                                                                                width: 100%;
                                                                                height: 100%;
                                                                            "
                                                                            format="MM/dd/yyyy"
                                                                            formControlName="activeDate"
                                                                            required
                                                                        ></kendo-datepicker>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                                <ng-container
                                                                    *ngIf="!hmdaIsEditing"
                                                                >
                                                                    <mat-form-field
                                                                        class="light-border text-field"
                                                                        outlined
                                                                        style="
                                                                            display: block;
                                                                            height: 56px;
                                                                        "
                                                                    >
                                                                        <kendo-datepicker
                                                                            class="no-border"
                                                                            format="MM/dd/yyyy"
                                                                            style="
                                                                                width: 100%;
                                                                                height: 100%;
                                                                            "
                                                                            formControlName="activeDate"
                                                                            required
                                                                        ></kendo-datepicker>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                            </td>
                                                            <td>
                                                                <ng-container *ngIf="hmdaIsEditing">
                                                                    <mat-form-field
                                                                        class="light-border text-field"
                                                                        outlined
                                                                        style="
                                                                            display: block;
                                                                            height: 56px;
                                                                        "
                                                                    >
                                                                        <kendo-datepicker
                                                                            style="
                                                                                width: 100%;
                                                                                height: 100%;
                                                                            "
                                                                            formControlName="inActiveDate"
                                                                            format="MM/dd/yyyy"
                                                                            required
                                                                        ></kendo-datepicker>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                                <ng-container
                                                                    *ngIf="!hmdaIsEditing"
                                                                >
                                                                    <mat-form-field
                                                                        class="light-border text-field"
                                                                        outlined
                                                                        style="
                                                                            display: block;
                                                                            height: 56px;
                                                                        "
                                                                    >
                                                                        <kendo-datepicker
                                                                            style="
                                                                                width: 100%;
                                                                                height: 100%;
                                                                            "
                                                                            formControlName="inActiveDate"
                                                                            format="MM/dd/yyyy"
                                                                            required
                                                                        ></kendo-datepicker>
                                                                    </mat-form-field>
                                                                </ng-container>
                                                            </td>
                                                            <td>
                                                                <div *ngIf="hmdaIsEditing">
                                                                    <span
                                                                        (click)="
                                                                            removeIdentity(
                                                                                'HMDA',
                                                                                i
                                                                            )
                                                                        "
                                                                        class="icon-container"
                                                                        style="
                                                                            font-size: 20px;
                                                                            padding-left: 10px;
                                                                            color: #b3b2b2;
                                                                        "
                                                                        ><mat-icon
                                                                            class="mat-icon"
                                                                            fontSet="fas"
                                                                            fontIcon="fa-trash-alt"
                                                                        ></mat-icon
                                                                    ></span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </tbody>
                                            </table>
                                        </form>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <div class="infoCard" style="float: left">
                            <div class="infoCardTitle">Company NMLS ID</div>
                            <div class="infoCardDetails">
                                <ng-container *ngIf="clientNmlsIdentities">
                                    <form
                                        [formGroup]="nmlsIdentityForm"
                                        (ngSubmit)="submitIdentityForm('nmls')"
                                    >
                                        <div style="display: flex; justify-content: flex-end">
                                            <ng-container *ngIf="nmlsIsEditing">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    (click)="addBlankIdentity('NMLS')"
                                                    style="height: 22px; width: 90px"
                                                >
                                                    Add
                                                </button>
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    (click)="submitIdentityForm('NMLS')"
                                                    style="
                                                        height: 22px;
                                                        width: 90px;
                                                        padding-left: 25px;
                                                    "
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    (click)="cancelEditedIdentities('NMLS')"
                                                    style="
                                                        height: 22px;
                                                        width: 90px;
                                                        padding-left: 25px;
                                                    "
                                                >
                                                    Cancel
                                                </button>
                                            </ng-container>
                                            <ng-container *ngIf="!nmlsIsEditing">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    (click)="addBlankIdentity('NMLS')"
                                                    style="height: 22px; width: 90px"
                                                >
                                                    Add
                                                </button>
                                                <ng-container
                                                    *ngIf="nmlsIdentityControlsArray.length !== 0"
                                                >
                                                    <button
                                                        type="button"
                                                        mat-raised-button
                                                        (click)="editIdentities('NMLS')"
                                                        style="
                                                            height: 22px;
                                                            width: 90px;
                                                            padding-left: 15px;
                                                        "
                                                    >
                                                        Edit
                                                    </button>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                        <ng-container
                                            *ngIf="
                                                (nmlsIdentityControlsArray.length === 0 &&
                                                    nmlsIsEditing) ||
                                                nmlsIdentityControlsArray.length !== 0
                                            "
                                        ></ng-container>
                                        <table class="identityTable">
                                            <thead>
                                                <tr>
                                                    <td>Identifier</td>
                                                    <td>Active Date</td>
                                                    <td>Inactive Date</td>
                                                    <td></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container
                                                    formArrayName="nmlsIdentityControlsArray"
                                                    *ngFor="
                                                        let nmlsId of nmlsIdentityControlsArray;
                                                        let j = index
                                                    "
                                                >
                                                    <tr [formGroupName]="j">
                                                        <td>
                                                            <ng-container *ngIf="nmlsIsEditing">
                                                                <mat-form-field class="form-field">
                                                                    <input
                                                                        formControlName="identifier"
                                                                        class="text-field"
                                                                        type="text"
                                                                        maxlength="20"
                                                                        outlined
                                                                        matInput
                                                                    />
                                                                </mat-form-field>
                                                            </ng-container>
                                                            <ng-container *ngIf="!nmlsIsEditing">
                                                                <mat-form-field class="form-field">
                                                                    <input
                                                                        formControlName="identifier"
                                                                        class="text-field"
                                                                        type="text"
                                                                        maxlength="20"
                                                                        outlined
                                                                        matInput
                                                                    />
                                                                </mat-form-field>
                                                            </ng-container>
                                                        </td>

                                                        <td>
                                                            <ng-container *ngIf="nmlsIsEditing">
                                                                <mat-form-field
                                                                    class="light-border text-field"
                                                                    outlined
                                                                    style="
                                                                        display: block;
                                                                        height: 56px;
                                                                    "
                                                                >
                                                                    <kendo-datepicker
                                                                        style="
                                                                            width: 100%;
                                                                            height: 100%;
                                                                        "
                                                                        formControlName="activeDate"
                                                                        format="MM/dd/yyyy"
                                                                        required
                                                                    ></kendo-datepicker>
                                                                </mat-form-field>
                                                            </ng-container>
                                                            <ng-container *ngIf="!nmlsIsEditing">
                                                                <mat-form-field
                                                                    class="light-border text-field"
                                                                    outlined
                                                                    style="
                                                                        display: block;
                                                                        height: 56px;
                                                                    "
                                                                >
                                                                    <kendo-datepicker
                                                                        style="
                                                                            width: 100%;
                                                                            height: 100%;
                                                                        "
                                                                        formControlName="activeDate"
                                                                        format="MM/dd/yyyy"
                                                                        required
                                                                    ></kendo-datepicker>
                                                                </mat-form-field>
                                                            </ng-container>
                                                        </td>
                                                        <td>
                                                            <ng-container *ngIf="nmlsIsEditing">
                                                                <mat-form-field
                                                                    class="light-border text-field"
                                                                    outlined
                                                                    style="
                                                                        display: block;
                                                                        height: 56px;
                                                                    "
                                                                >
                                                                    <kendo-datepicker
                                                                        style="
                                                                            width: 100%;
                                                                            height: 100%;
                                                                        "
                                                                        formControlName="inActiveDate"
                                                                        format="MM/dd/yyyy"
                                                                        required
                                                                    ></kendo-datepicker>
                                                                </mat-form-field>
                                                            </ng-container>
                                                            <ng-container *ngIf="!nmlsIsEditing">
                                                                <mat-form-field
                                                                    class="light-border text-field"
                                                                    outlined
                                                                    style="
                                                                        display: block;
                                                                        height: 56px;
                                                                    "
                                                                >
                                                                    <kendo-datepicker
                                                                        style="
                                                                            width: 100%;
                                                                            height: 100%;
                                                                        "
                                                                        formControlName="inActiveDate"
                                                                        format="MM/dd/yyyy"
                                                                        required
                                                                    ></kendo-datepicker>
                                                                </mat-form-field>
                                                            </ng-container>
                                                        </td>
                                                        <td>
                                                            <div *ngIf="nmlsIsEditing">
                                                                <span
                                                                    (click)="
                                                                        removeIdentity('NMLS', j)
                                                                    "
                                                                    class="icon-container"
                                                                    style="
                                                                        font-size: 20px;
                                                                        padding-left: 10px;
                                                                        color: #b3b2b2;
                                                                    "
                                                                    ><mat-icon
                                                                        class="mat-icon"
                                                                        fontSet="fas"
                                                                        fontIcon="fa-trash-alt"
                                                                    ></mat-icon
                                                                ></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </form>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>
            <br />
            <br />
            <span class="settings-sub-heading">Company Integrations</span>
            <app-lba-client-integrations
                [shortName]="clientShortName"
            ></app-lba-client-integrations>
        </ng-container>
    </div>
    <!-- ADD NEW USER MENU -->
    <div [ngClass]="{ 'middle-layer-for-page-disable': isEditMenuOpen }"></div>
    <div id="admin-background" *ngIf="isEditMenuOpen">
        <app-client-slideout-view
            [editing]="false"
            (updatePage)="updatePageFromSideBar($event)"
        ></app-client-slideout-view>
    </div>
    <div
        *ngIf="fromClient"
        style="position: absolute; right: 0; bottom: 0; text-align: right; padding: 24px"
    >
        <button mat-button type="button" (click)="cancelClicked()" style="margin-right: 16px">
            Go Back To Clients
        </button>
    </div>
</mat-card>
